const MIDDLE_PAGE_PREFIX = 'middle';
const MIDDLE_PAGE_PATTERN = /^middle(?:[2-9]\d*)?$/;

export function isMiddlePage(value?: string): value is string {
  return !!value && MIDDLE_PAGE_PATTERN.test(value);
}

export function getMiddlePageOrder(value?: string): number {
  if (!isMiddlePage(value)) {
    return Number.MAX_SAFE_INTEGER;
  }
  return value === MIDDLE_PAGE_PREFIX ? 1 : Number(value.slice(MIDDLE_PAGE_PREFIX.length));
}

export function buildMiddlePageValue(order: number): string {
  if (order <= 1) {
    return MIDDLE_PAGE_PREFIX;
  }
  return `${MIDDLE_PAGE_PREFIX}${order}`;
}

export function isFormPage(value?: string): boolean {
  return value === 'start' || isMiddlePage(value);
}

export function getFormPageValues(pageSettings: Array<{ value: string }> = []): string[] {
  return pageSettings.map(item => item.value).filter(isFormPage);
}

export function getMiddlePageValues(pageSettings: Array<{ value: string }> = []): string[] {
  return getFormPageValues(pageSettings).filter(isMiddlePage);
}

export function getNextAvailableMiddlePageValue(pageSettings: Array<{ value: string }> = []): string | undefined {
  const usedOrders = new Set(getMiddlePageValues(pageSettings).map(getMiddlePageOrder));
  let nextOrder = 1;
  while (usedOrders.has(nextOrder)) {
    nextOrder += 1;
  }
  return buildMiddlePageValue(nextOrder);
}

export function getPreviousFormPageValue(pageSettings: Array<{ value: string }> = [], currentValue?: string): string | undefined {
  const formPages = getFormPageValues(pageSettings);
  const index = formPages.indexOf(currentValue || '');
  return index > 0 ? formPages[index - 1] : undefined;
}

export function getNextFormPageValue(pageSettings: Array<{ value: string }> = [], currentValue?: string): string | undefined {
  const formPages = getFormPageValues(pageSettings);
  const index = formPages.indexOf(currentValue || '');
  return index > -1 ? formPages[index + 1] : undefined;
}

export function getLastFormPageValue(pageSettings: Array<{ value: string }> = []): string {
  const formPages = getFormPageValues(pageSettings);
  return formPages[formPages.length - 1] || 'start';
}

export function isEmailPhoneStepForm(startForms: Array<{ type?: string }> = [], endForms?: any[]): boolean {
  const disabled = (startForms || []).reduce(
    (info: { ok: Set<string>; err: Set<string>; disabled: boolean }, form: { type?: string }, index: number, arr: Array<{ type?: string }>) => {
      if (form.type === 'Email' || form.type === 'Mobile Number') {
        info.ok.add(form.type);
      } else {
        info.err.add(form.type || '');
      }
      let newdisabled = true;
      if (arr.length === 2) {
        newdisabled = !(arr[0]?.type === 'Email' && arr[1]?.type === 'Mobile Number');
      } else {
        newdisabled = info.ok.size !== 2 || info.err.size !== 0;
      }
      info.disabled = newdisabled;
      return info;
    },
    { ok: new Set<string>(), err: new Set<string>(), disabled: true }
  ).disabled || !endForms || endForms.length !== 0;

  return !disabled;
}

export function isShortFormTemplate(formData: any, templateId?: string | number | null): boolean {
  const tid = `${Number(templateId) || formData?.templateId || ''}`;
  return (
    tid === '36' ||
    tid === '37' ||
    tid === '38' ||
    tid === '39' ||
    tid === '40' ||
    tid === '42' ||
    tid === '43' ||
    `${formData?.id}` === '1e1609bc024d4517989039886ac7ed34' ||
    `${formData?.id}` === 'abdac5d809824d8280ffff395a854a15'
  );
}

export function isCustomStepLimitExcludedForm(formData: any, templateId?: string | number | null): boolean {
  const tid = `${Number(templateId) || formData?.templateId || ''}`;
  return tid === '126';
}

export function getMiddlePageScopedField(pageValue: string | undefined, middleField: string): string {
  if (!isMiddlePage(pageValue) || pageValue === 'middle') {
    return middleField;
  }
  if (!middleField.startsWith('middle')) {
    return middleField;
  }
  return `${pageValue}${middleField.slice('middle'.length)}`;
}
